// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"JK-z","upvoteIcon":"KK-z","downvoteIcon":"LK-z","feedbackIcon":"MK-z"};